import React, { useState, useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { animated, useSpring } from 'react-spring';

import 'assets/styles/index.scss';
import IntroView from 'views/IntroView';
import FormView from 'views/FormView';
import MainView from 'views/MainView';
import DoneView from 'views/DoneView';
import MockupView from 'views/MockupView';

const App = () => {
  const isPortrait = window.orientation === 0;
  const isPortraitMobile = isPortrait && isMobile;
  const country = window.location.pathname.substring(1) || 'my';
  const isId = country === 'id';
  const [XTransition, setXTransition] = useState(0);
  const [YTransition, setYTransition] = useState(0);
  const [hideIntro, setHideIntro] = useState(isPortraitMobile ? true : false);
  const [start, set] = useState(false);
  const ref = useRef();

  const scrollDown = useSpring({
    transform: `translateY(${hideIntro ? -window.innerHeight : '0px'})`,
  });

  // use intersection observer to trigger animations only when mainview is on screen
  useEffect(() => {
    const main = ref.current;
    if (!main) return;
    const intersectionOptions = {
      threshold: 0.1,
    };
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        set(entry.isIntersecting);
        if (entry.isIntersecting) {
          obs.unobserve(main);
        }
      });
    }, intersectionOptions);
    observer.observe(main);
    return () => {
      observer.unobserve(main);
    };
  }, [ref]);

  useEffect(() => {
    // issue of vh in mobile https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    document
      .querySelector(':root')
      .style.setProperty('--vh', window.innerHeight / 100 + 'px');

    // opening up keyboard messes up viewport https://stackoverflow.com/questions/32963400/android-keyboard-shrinking-the-viewport-and-elements-using-unit-vh-in-css
    const viewport = document.querySelector('meta[name=viewport]');
    viewport.setAttribute(
      'content',
      viewport.content + ', height=' + window.innerHeight
    );
  }, []);

  return (
    <div>
      <animated.div
        className="intro-container"
        style={!isPortraitMobile ? scrollDown : {}}
      >
        {!isPortraitMobile && (
          <IntroView hideIntro={setHideIntro} isId={isId} />
        )}
        <div
          className="x-container"
          style={{ transform: XTransition }}
          ref={ref}
        >
          <MainView
            setXTransition={setXTransition}
            start={start}
            country={country}
            isId={isId}
            isPortraitMobile={isPortraitMobile}
          />
          {!isPortraitMobile && <MockupView start={start} />}
          <div className="y-container" style={{ transform: YTransition }}>
            <FormView
              setXTransition={setXTransition}
              setYTransition={setYTransition}
              isId={isId}
              country={country}
            />
            <DoneView
              setXTransition={setXTransition}
              setYTransition={setYTransition}
              isId={isId}
            />
          </div>
        </div>
      </animated.div>
    </div>
  );
};

export default App;
